import { render, staticRenderFns } from "./HolidaySettingsTableControl.vue?vue&type=template&id=0be0097a&scoped=true&"
import script from "./HolidaySettingsTableControl.vue?vue&type=script&lang=js&"
export * from "./HolidaySettingsTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be0097a",
  null
  
)

export default component.exports